import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=2a888fa0&"
import script from "./FooterComponent.vue?vue&type=script&lang=ts&"
export * from "./FooterComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a888fa0')) {
      api.createRecord('2a888fa0', component.options)
    } else {
      api.reload('2a888fa0', component.options)
    }
    module.hot.accept("./FooterComponent.vue?vue&type=template&id=2a888fa0&", function () {
      api.rerender('2a888fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Header/FooterComponent.vue"
export default component.exports